import React from 'react';
import {
  InsuranceDTO,
  InsuranceType,
  PropertyPremiumFrequencyDTO,
} from '../../api/useInsuranceQuery';
import { InsuranceTable } from '../../components/InsuranceTable/InsuranceTable';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { formatCurrency } from '../../../../CommonUtils/formatNumber';
import { ColumnHeader } from '../../../OtherAssets/OtherAssets.meta';
import { InsuranceToDelete, InsuranceToUpsert } from '../../Insurance.meta';
import { TableActions } from '../../components/TableActions/TableActions';
import { WorkflowComponentProps } from '../../../../Workflow/Workflow.meta';
import { useIsPdf } from '../../../../FinancialPlanOPL/hooks/useIsPdf';

const columnHeaders: ColumnHeader[] = [
  { text: 'Description' },
  { text: 'Owner' },
  { text: 'Coverage Period' },
  { text: 'Coverage Amount', align: 'right' },
  { text: 'Premium Amount', align: 'right' },
  { text: 'Frequency' },
];

interface Props {
  data: InsuranceDTO;
  setInsuranceToUpsert(insurance: InsuranceToUpsert): void;
  setInsuranceToDelete(insurance: InsuranceToDelete): void;
  workflowProps?: WorkflowComponentProps;
}

export const PropertyAndCasualty = ({
  data,
  setInsuranceToUpsert,
  setInsuranceToDelete,
  workflowProps,
}: Props) => {
  const items = data.Items.PropertyAndCasualty || [];

  const isPrint = useIsPdf();

  return (
    <InsuranceTable
      title="Property & Casualty Insurance Policies"
      isEmpty={items.length === 0}
      columnHeaders={columnHeaders}
      onAddInsurance={() =>
        setInsuranceToUpsert({ InsuranceType: InsuranceType.PropertyAndCasualty })
      }
      workflowProps={workflowProps}
    >
      {items.map(
        insurance =>
          insurance.PropertyAndCasualtyInsuranceDetails && (
            <tr key={insurance.AccountId}>
              <td>
                <Text fontWeight={500} width="100%">
                  {insurance.Description}
                </Text>
              </td>

              <td>
                <Text fontWeight={500}>{insurance.AccountOwner}</Text>
              </td>

              <td>
                <Text fontWeight={500}>
                  {insurance.PropertyAndCasualtyInsuranceDetails.CoverageStartYear}-
                  {insurance.PropertyAndCasualtyInsuranceDetails.CoverageEndYear ?? 'End of Plan'}
                </Text>
              </td>

              <td>
                <Text fontWeight={500} textAlign="right">
                  {formatCurrency(insurance.PropertyAndCasualtyInsuranceDetails.Coverage)}
                </Text>
              </td>

              <td>
                <Text variant="tabular" fontWeight={500} textAlign="right">
                  {formatCurrency(insurance.Premium)}
                </Text>
              </td>

              <td>
                <Text variant="tabular" fontWeight={500}>
                  {
                    PropertyPremiumFrequencyDTO[
                      insurance.PropertyAndCasualtyInsuranceDetails.PremiumPaymentFrequency
                    ]
                  }
                </Text>
              </td>

              {!isPrint && (
                <TableActions
                  insuranceName={insurance.Description}
                  onEdit={() => setInsuranceToUpsert(insurance)}
                  onDelete={() => setInsuranceToDelete({ id: insurance.AccountId })}
                />
              )}
            </tr>
          ),
      )}
    </InsuranceTable>
  );
};
